"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importDefault(require("react"));
const icon_1 = require("../icon");
const styles_1 = require("./styles");
const { input: Input, switch: { indicator: Indicator, root: Root }, } = styles_1.styles;
const Switch = ({ active, disabled = false, variant = "default", ...props }) => {
    return (react_1.default.createElement("label", null,
        react_1.default.createElement(Input, Object.assign({ checked: active, disabled: disabled, type: "checkbox" }, props)),
        react_1.default.createElement(Root, { active: active, disabled: disabled, variant: variant },
            react_1.default.createElement(Indicator, { active: active },
                react_1.default.createElement(icon_1.Icon, { size: 8, use: active ? "check" : "x" })))));
};
exports.Switch = Switch;
